import script from "./CensusHoldingCreation.vue?vue&type=script&setup=true&lang=js"
export * from "./CensusHoldingCreation.vue?vue&type=script&setup=true&lang=js"

import "./CensusHoldingCreation.vue?vue&type=style&index=0&id=5fdd622c&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fdd622c"]])

export default __exports__